// Berro Orthodontics (Los Alamitos CA) - single office.
// Backend: bondLocations.ts BERRO_LOS_ALAMITOS (brandId "berro", catalog 25158772,
// Edge loc 1, procedure 208, DB 270). Native booking via ortho2-newpatient backend
// (WCF intake disabled - login not provisioned on DB 270). English-only.
import type { BrandConfig } from "./types";

export const berro: BrandConfig = {
  slug: "berro",
  brandId: "berro",
  brandName: "Berro Orthodontics",
  logo: "https://berroorthodontics.com/wp-content/uploads/2022/12/Berro_Logo_wide-1.png",
  phone: "(562) 598-3333",
  phoneHref: "tel:+15625983333",
  theme: { primary: "#074289", primaryDark: "#293758" }, // scoured 2026-07-14 berroorthodontics.com (deep blue + gold accent)
  locales: ["en"],
  locations: {
    BERRO_LOS_ALAMITOS: {
      id: "BERRO_LOS_ALAMITOS",
      name: "Los Alamitos",
      addressLines: ["3662 Katella Ave., Suite 200", "Los Alamitos, CA 90720"],
      mapsUrl: "https://maps.google.com/?q=3662+Katella+Ave+Suite+200+Los+Alamitos+CA+90720",
      timezone: "America/Los_Angeles",
    },
  },
  locationAliases: { LOS_ALAMITOS: "BERRO_LOS_ALAMITOS", BERRO: "BERRO_LOS_ALAMITOS" },
};
